const baseURL = 'https://cogelobarato.com/';

export default baseURL;
